import evalCondition from 'Helpers/evalCondition'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { Button, PageHeader } from 'mailup-web-components'
import { modalNewSourceState } from 'Pages/SourcesList/recoil/state/modals'
import { pageState } from 'Pages/SourcesList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { isEmptyState } = useRecoilValue(pageState)
  const setShowModal = useSetRecoilState(modalNewSourceState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['ContentsSourcesList', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
      'data-mu-test': 'breadcrumb-item__sources',
      className: 'test-breadcrumb-item__sources'
    }
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
      'data-mu-test': 'topmenu-item__contentsSources',
      className: 'test-topmenu-item__contentsSources',
      onClick: () => history.push('/automation/sources/list'),
      isActive: true
    },
    ...(evalCondition('uo:NL AND uo:ENHTRIGGEREDUSE AND co:ENHTRIGGEREDUSE')
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.NavMenu.ContentsCampaignList'
            }),
            onClick: () => history.push('/automation/contentsCampaign/list'),
            'data-mu-test': 'topmenu-item__contentsCampaignList',
            className: 'test-topmenu-item__contentsCampaignList'
          }
        ]
      : []),
    ...(evalCondition('uo:DYNFLD')
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.DynamicContent' }),
            onClick: () => history.push('/automation/dynamiccontent/list'),

            'data-mu-test': 'topmenu-item__emailSmtpPlusList',
            className: 'test-topmenu-item__emailSmtpPlusList'
          }
        ]
      : [])
  ]

  const ControlsComponent = () =>
    isEmptyState ? null : (
      <Button
        kind='primary'
        size='lg'
        onClick={() => setShowModal(true)}
        data-mu-test='header-button'
      >
        {intl.formatMessage({ id: 'Load.ContentsSouces.NewSource' })}
      </Button>
    )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      ControlsComponent={ControlsComponent}
      title={intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' })}
    />
  )
}

export default Header
